module.exports = __webpack_public_path__ + "img/video02.43811116.jpg";